// extracted by mini-css-extract-plugin
export default {"balloon":"balloonSupplier_balloon__pMaMT","text":"balloonSupplier_text__iIb4G","ballMinH":"balloonSupplier_ballMinH__Czm9v","textMinH":"balloonSupplier_textMinH__BqVI1"};